
export default "/assets/bluesky.aaed48f5.svg"